<template>
    <div>
        <i class="loader fas fa-spinner fa-spin fa-2x"></i>
    </div>
</template>

<script>
export default {
    name: "Loader"
}
</script>

<style scoped>
    .loader {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>